import React, { Fragment } from "react";
import { H5, Image, LI } from "../../../AbstractElements";
import { Link } from "react-router-dom";
import { Button, Input, InputGroup } from "reactstrap";
import { X } from "react-feather";
import { CART } from "../../../Data/Header/Cart";
import { Href } from "../../../Constant";

const CartList = () => {
  return (
    <Fragment>
      {CART.map((item, index) => (
        <LI key={index}>
          <div className="d-flex">
            <Image className="b-r-5 me-3 img-60 image-fluid" src={item.src} alt="" />
            <div className="flex-grow-1">
              <Link to={`${process.env.PUBLIC_URL}/ecommerce/product`}><span>{item.title}</span></Link>
              <div className="qty-box">
                <InputGroup>
                  <span className="input-group-prepend">
                    <Button className="quantity-left-minus" data-type="minus" data-field="">-</Button>
                  </span>
                  <Input className="form-control input-number f-14 f-w-500" type="text" name="quantity" defaultValue="1" />
                  <span className="input-group-prepend">
                    <Button className="quantity-right-plus" data-type="plus" data-field="">+</Button>
                  </span>
                </InputGroup>
              </div>
              <H5 className="font-primary">{item.price}</H5>
            </div>
            <div className="close-circle">
              <a className="bg-danger" href={Href}><X /></a>
            </div>
          </div>
        </LI>
      ))}
    </Fragment>
  );
};

export default CartList;
